'use client';

import { useEffect } from 'react';
import { trackEvent } from 'utils/analytics';

const DisclaimerPageViewTracker = () => {
  useEffect(() => {
    trackEvent('viewed_disclaimer_page');
  }, []);

  return null;
};

export default DisclaimerPageViewTracker;
